import React, { PropsWithChildren } from 'react';

export function Message({ children }: PropsWithChildren<unknown>) {
  return <span className="status-info__text">{children}</span>;
}
